import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const OrganogramHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
`

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`

export const PanelContainer = styled.div`
  ${(props) => props.theme.container};
  color: ${tokens.text.primary};
  padding: 1rem 1.25rem;
`

export const PanelTitle = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: ${tokens.text.primary};
  margin-bottom: 1rem;
`

export const AlertsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const AlertRow = styled.div<{ accentColor: string }>`
  padding: 0.75rem 1rem;
  border-radius: 10px;
  background: ${(props) => props.accentColor}14;
  border: 1px solid ${(props) => props.accentColor}40;
  color: ${(props) => props.accentColor};
`

export const FiltersRow = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 2fr) repeat(3, minmax(150px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

export const ModalFieldHelp = styled.div`
  font-size: 0.75rem;
  color: ${tokens.text.secondary};
  margin-top: 0.25rem;
`

export const ModalLabel = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${tokens.text.primary};
  margin-bottom: 0.375rem;
`

export const ModalRow = styled.div`
  margin-bottom: 1rem;
`

export const BackLink = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  color: ${tokens.text.primary};
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 1.25rem;
  svg {
    width: 28px;
    height: 28px;
  }
`

export const TeamHeroCard = styled.div`
  ${(props) => props.theme.container};
  color: ${tokens.text.primary};
  padding: 1.25rem 1.5rem;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 1.25rem;
  align-items: start;
  margin-bottom: 1.25rem;
`

export const TeamHeroIcon = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: ${tokens.accent.soft};
  color: ${tokens.accent.base};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 32px;
    height: 32px;
  }
`

export const EmployeeAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${tokens.accent.base};
  color: ${tokens.accent.ink};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
  }
`

export const TeamHeroMeta = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, max-content));
  gap: 1.5rem;
  margin-top: 0.75rem;
`

export const MetaLabel = styled.div`
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${tokens.text.secondary};
  font-weight: 600;
  margin-bottom: 0.25rem;
`

export const EscalationSection = styled.div`
  ${(props) => props.theme.container};
  color: ${tokens.text.primary};
  padding: 1rem 1.25rem;
  margin-top: 1.25rem;
`

export const EscalationChain = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
`

export const EscalationChip = styled.div`
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid ${tokens.border.hairline};
  font-size: 0.875rem;
  color: ${tokens.text.primary};
  background: ${tokens.surface.inset};
`

export const EscalationArrow = styled.div`
  color: ${tokens.accent.base};
  font-size: 1rem;
`

export const OutlineActionButton = styled.button<{ accent?: boolean }>`
  background: transparent;
  border: 1px solid
    ${(props) => (props.accent ? tokens.accent.base : tokens.border.hairline)};
  color: ${(props) => (props.accent ? tokens.accent.base : tokens.text.primary)};
  border-radius: 10px;
  padding: 0.5rem 1.1rem;
  height: 40px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    filter: brightness(115%);
  }
`

export const TeamsRowClickable = styled.div`
  cursor: pointer;
  &:hover {
    background: ${tokens.surface.inset};
  }
`

export const OrgStructureHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`

export const LegendRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`

export const LegendItem = styled.div<{ accentColor: string }>`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.875rem;
  color: ${tokens.text.primary};

  &::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${(props) => props.accentColor};
  }
`

export const TreeScroll = styled.div`
  ${(props) => props.theme.container};
  color: ${tokens.text.primary};
  padding: 1.5rem;
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 1rem;
`

export const TreeRoot = styled.div`
  display: inline-flex;
  justify-content: center;
  min-width: 100%;
`

export const TreeNodeBox = styled.div<{ accentColor: string; selected?: boolean }>`
  position: relative;
  min-width: 180px;
  max-width: 220px;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  border: 1px solid ${(props) => props.accentColor};
  background: ${(props) => props.accentColor}14;
  color: ${(props) => props.accentColor};
  cursor: pointer;
  text-align: center;
  transition: 0.2s ease;

  ${(props) =>
    props.selected &&
    `
    box-shadow: 0 0 0 2px ${props.accentColor}40;
  `}

  &:hover {
    background: ${(props) => props.accentColor}24;
  }
`

export const TreeNodeTitle = styled.div`
  font-weight: 700;
  font-size: 0.95rem;
  color: inherit;
`

export const TreeNodeSubtitle = styled.div`
  font-size: 0.75rem;
  color: ${tokens.text.primary};
  margin-top: 0.25rem;
  opacity: 0.8;
`

export const TreeNodeCount = styled.div`
  font-size: 0.75rem;
  color: ${tokens.text.primary};
  margin-top: 0.375rem;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  opacity: 0.85;
`

export const TreeNodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 0 0.5rem;

  /* connector from this node down to children container */
  &:not(.root):before {
    content: '';
    position: absolute;
    top: -16px;
    left: 50%;
    width: 2px;
    height: 16px;
    background: ${tokens.border.hairline};
  }
`

export const TreeChildrenRow = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-top: 24px;
  position: relative;

  /* horizontal bar connecting children */
  &:before {
    content: '';
    position: absolute;
    top: -16px;
    left: 10%;
    right: 10%;
    height: 2px;
    background: ${tokens.border.hairline};
  }

  /* vertical drop from parent into the bar */
  &:after {
    content: '';
    position: absolute;
    top: -32px;
    left: 50%;
    width: 2px;
    height: 16px;
    background: ${tokens.border.hairline};
  }
`

export const SelectedPersonCard = styled.div`
  ${(props) => props.theme.content};
  color: ${tokens.text.primary};
  border-left: 3px solid ${tokens.status.success.fg};
  padding: 0.875rem 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
`

export const MembersSimpleHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.5fr 1.5fr;
  gap: 1rem;
  padding: 0.75rem 1.25rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.05em;
  color: ${tokens.text.secondary};
  border-bottom: 1px solid ${tokens.border.hairline};
`

export const MembersSimpleRow = styled.div<{ highlighted?: boolean }>`
  display: grid;
  grid-template-columns: 2fr 1.5fr 1.5fr;
  gap: 1rem;
  padding: 0.875rem 1.25rem;
  align-items: center;
  font-size: 0.875rem;
  color: ${tokens.text.primary};
  cursor: pointer;
  ${(props) =>
    props.highlighted
      ? `border: 1px solid ${tokens.accent.base};
         border-radius: 10px;
         margin: 0.25rem 0.75rem;`
      : `border-bottom: 1px solid ${tokens.border.hairline};`}
`

export const MembersSimpleTable = styled.div`
  ${(props) => props.theme.container};
  color: ${tokens.text.primary};
  padding: 0.25rem 0;
`

export const TableHeaderRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1.5fr;
  padding: 0.75rem 1rem;
  gap: 1rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.05em;
  color: ${tokens.text.secondary};
  border-bottom: 1px solid ${tokens.border.hairline};
`

export const TableBodyRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1.5fr;
  padding: 0.875rem 1rem;
  gap: 1rem;
  align-items: center;
  border-bottom: 1px solid ${tokens.border.hairline};
  color: ${tokens.text.primary};
  font-size: 0.875rem;
`

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`

export const SearchField = styled.div`
  ${(props) => props.theme.container};
  color: ${tokens.text.primary};
  flex: 1;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;

  input {
    background: transparent;
    border: none;
    outline: none;
    color: inherit;
    font-size: 0.95rem;
    flex: 1;
    min-width: 0;
    padding: 0.4rem 0;
  }

  input::placeholder {
    color: ${tokens.text.secondary};
  }
`

export const RoleChipsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`

export const RoleChip = styled.div`
  padding: 4px 10px;
  border-radius: 999px;
  background: ${tokens.surface.inset};
  color: ${tokens.text.primary};
  font-size: 0.8rem;
  border: 1px solid ${tokens.border.hairline};
`

export const PeopleCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const AssignmentsFiltersRow = styled.div`
  display: grid;
  grid-template-columns: minmax(260px, 2fr) repeat(2, minmax(0, 1fr)) 40px;
  gap: 0.75rem;
  margin-bottom: 1rem;
  align-items: center;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr 1fr;
  }
`

export const FilterIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid ${tokens.border.hairline};
  background: transparent;
  color: ${tokens.text.primary};
  cursor: pointer;

  &:hover {
    filter: brightness(115%);
  }
`

export const CurrentAssignmentBox = styled.div`
  ${(props) => props.theme.content};
  padding: 0.875rem 1rem;
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 0.5rem 1rem;
  font-size: 0.875rem;
  color: ${tokens.text.primary};
  margin-bottom: 1rem;
`

export const CurrentAssignmentLabel = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: ${tokens.text.secondary};
  font-size: 0.875rem;
`

export const CurrentAssignmentSectionLabel = styled.div`
  grid-column: 1 / -1;
  font-size: 0.75rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${tokens.text.secondary};
  font-weight: 600;
  margin-bottom: 0.25rem;
`

export const ReadonlyField = styled.div`
  border: 1px solid ${tokens.border.hairline};
  border-radius: 12px;
  padding: 0.75rem 1rem;
  color: ${tokens.text.primary};
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const ReadonlyFieldLabel = styled.div`
  font-size: 0.7rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${tokens.text.secondary};
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
`

export const ReadonlyFieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
`

export const ComingSoonPanel = styled.div`
  ${(props) => props.theme.container};
  color: ${tokens.text.primary};
  padding: 3rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 260px;
`
